interface IIconProps {
  size?: number;
  color?: string;
}

const LeaguePromotionsIcon = ({ size, color }: IIconProps) => (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="4" width="32" height="32" rx="3.2" fill="url(#paint0_linear_1341_28381)"/>
<rect x="4.78" y="4.78" width="30.44" height="30.44" rx="2.42" stroke="url(#paint1_linear_1341_28381)" strokeWidth="1.56"/>
<path d="M22.7998 19.9709L24.3998 18.3782L19.5997 13.6001L14.7998 18.3782L16.3998 19.9709L18.4684 17.9116V26.4001H20.7311V17.9116L22.7998 19.9709Z" fill="white"/>
<defs>
<linearGradient id="paint0_linear_1341_28381" x1="20" y1="4" x2="20" y2="36" gradientUnits="userSpaceOnUse">
<stop stopColor="#77FECC"/>
<stop offset="1" stopColor="#46D9A4"/>
</linearGradient>
<linearGradient id="paint1_linear_1341_28381" x1="13.0177" y1="15.8519" x2="25.1746" y2="25.1017" gradientUnits="userSpaceOnUse">
<stop stopColor="#46D9A4"/>
<stop offset="0.429043" stopColor="#CAFFEC"/>
<stop offset="1" stopColor="#46D9A4"/>
</linearGradient>
</defs>
</svg>

);

LeaguePromotionsIcon.defaultProps = {
  size: 46,
  color: 'currentColor',
};

export default LeaguePromotionsIcon;
